import { TaxLineItem } from '@/modules/tax/models/TaxLineItem';

export class CalculatorLineItem extends TaxLineItem {}
